import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getTableSettingsByStatuses } from '../constants/listingsBreakdownSettings';
import { useMarketDynamicsStore } from '../../store/marketDynamics/store';
import { translatedStatusesOptions } from '../helpers/breakdowns';
import { BreakdownTable } from './common/BreakdownTable';
import { useSearchStore } from '../../store/store';

const ListingsBreakdownTable = ({
    listingStatus,
    tableTitleWithTooltips,
    searchCriteria,
    gridRef,
    tabIndex,
    isOfficeListing,
}) => {
    const location = useLocation();
    const {
        getListingsBreakdown,
        selectedBreakdownPeriod,
    } = useMarketDynamicsStore(state => ({
        getListingsBreakdown: state.getListingsBreakdown,
        selectedBreakdownPeriod: state.selectedBreakdownPeriod,
    }));

    const {
        shouldShowAdditionalInfo,
        setIsFooterDisabled,
        setTabListingStatus,
        selectedBreakdownOffice,
    } = useSearchStore(state => {
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns } = moduleState;
        const { selectedBreakdownTab, tabsByRoute, selectedBreakdownOffice } = breakdowns;
        const breakdownTabData = tabsByRoute[location.pathname]?.[selectedBreakdownTab];
        return ({
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo,
            setIsFooterDisabled: state.setIsFooterDisabled,
            setTabListingStatus: state.setTabListingStatus,
            selectedBreakdownOffice,
        });
    });
    const [state, setState] = useState({
        listings: [],
        isLoading: true,
    });
    const tableView = getTableSettingsByStatuses(shouldShowAdditionalInfo)[listingStatus.id];

    const getTabIndex = () => isOfficeListing ? tabIndex - 1: tabIndex;

    useEffect(() => {
        if (!searchCriteria || !selectedBreakdownPeriod) return;
        setState(state => ({
            ...state,
            listings: [],
            isLoading: true,
        }));
        const getListings = async () => {
            setIsFooterDisabled(getTabIndex(), true, location.pathname);
            setTabListingStatus(getTabIndex(), listingStatus, location.pathname);
            const listings = await getListingsBreakdown(
                searchCriteria,
                translatedStatusesOptions[listingStatus.id],
                isOfficeListing,
                selectedBreakdownOffice?.officeId
            );
            setState(state => ({
                ...state,
                listings,
                isLoading: false
            }));
        };
        getListings();
    }, [searchCriteria, selectedBreakdownPeriod, listingStatus.id, isOfficeListing, selectedBreakdownOffice]);

    useEffect(() => {
        setIsFooterDisabled(getTabIndex(), state.isLoading, location.pathname);
    }, [state.isLoading, location.pathname]);

    return <BreakdownTable
                gridRef={gridRef}
                rowData={state.listings}
                tableTitleWithTooltips={tableTitleWithTooltips}
                tableView={tableView}
                isLoading={state.isLoading} />
};

export default ListingsBreakdownTable;

ListingsBreakdownTable.propTypes = {
    listingStatus: PropTypes.object,
    tableTitleWithTooltips: PropTypes.object,
    searchCriteria: PropTypes.object,
    gridRef: PropTypes.object,
    tabIndex: PropTypes.number,
    isOfficeListing: PropTypes.bool,
};
